<template>
  <div class="box">
    <dv-loading class="loadingCss" v-if="loading">Loading...</dv-loading>
    <div v-show="!loading" class="boxOnePhoto">
      <img :src="item.bgiFileId" @load="imgOver" class="bigPhoto" />
      <p class="catSmall">
        <!-- <el-input v-model="radio" placeholder="请输入内容" style="width:50%"></el-input> -->
        <el-select
          v-model="radio"
          placeholder="请选择"
          style="width: 100%"
          @change="photoClick"
        >
          <el-option
            v-for="item in teacherArray"
            :key="item.id"
            :label="item.id"
            :value="item.id"
          ></el-option>
        </el-select>
      </p>
    </div>
  </div>
</template>

<script>
import drawMixin from '@/utils/drawMixin.js';
export default {
  name: 'Rotating-picture',
  mixins: [drawMixin],
  components: {},
  props: {
    item: {
      default: () => {}
    },
    echo: {
      default: null
    }
  },
  data() {
    return {
      radio: '',
      teacherArray: [
        { id: 1 },
        { id: 2 },
        { id: 3 },
        { id: 4 },
        { id: 5 },
        { id: 6 },
        { id: 7 },
        { id: 8 },
        { id: 9 },
        { id: 10 },
        { id: 11 },
        { id: 12 },
        { id: 13 },
        { id: 14 },
        { id: 15 },
        { id: 16 },
        { id: 17 },
        { id: 18 },
        { id: 19 },
        { id: 20 },
        { id: 21 },
        { id: 22 },
        { id: 23 },
        { id: 24 },
        { id: 25 },
        { id: 26 },
        { id: 27 },
        { id: 28 },
        { id: 29 },
        { id: 30 }
      ],
      count: 0,
      loading: true
    };
  },
  created() {},
  mounted() {},
  watch: {
    echo: {
      handler(newVal) {
        if (newVal) {
          this.radio = newVal;
          this.$emit('nextTopic', this.radio);
        }
      },
      immediate: true
    }
  },
  computed: {},
  methods: {
    photoClick() {
      this.$emit('nextTopic', this.radio);
    },
    imgOver() {
      this.count++;
      if (this.count == 1) {
        this.loading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}
.boxOnePhoto {
  display: flex;
  justify-content: center;
  .bigPhoto {
    width: 60%;
  }
}
.catSmall {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  margin-left: 10px;
}
</style>